'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError from "./com.raquo.airstream.core.-Airstream-Error.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024 from "./com.raquo.airstream.core.-Airstream-Error$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
class $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError extends $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError.$c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(error, cause) {
    super();
    this.rx = null;
    this.rw = null;
    this.rx = error;
    this.rw = cause;
    $j_java$002elang$002e$002dObject.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, ((("ObserverErrorHandlingError: " + $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().kT(error)) + "; cause: ") + $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().kT(cause)), null, true, true);
    this.BO(cause);
  }
  I() {
    return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
  }
  m() {
    return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
  }
  f(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError)) {
      var x = this.rx;
      var x$2 = x$0.rx;
      if (((x === null) ? (x$2 === null) : x.f(x$2))) {
        var x$3 = this.rw;
        var x$4 = x$0.rw;
        return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  n() {
    return 2;
  }
  o() {
    return "ObserverErrorHandlingError";
  }
  g(n) {
    if ((n === 0)) {
      return this.rx;
    }
    if ((n === 1)) {
      return this.rw;
    }
    throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  b() {
    return ((("ObserverErrorHandlingError: " + this.rx) + "; cause: ") + this.rw);
  }
}
export { $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError as $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError };
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cO)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError as $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError };
var $d_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError, "com.raquo.airstream.core.AirstreamError$ObserverErrorHandlingError", ({
  cO: 1,
  bl: 1,
  H: 1,
  a: 1,
  b: 1,
  c: 1
}));
export { $d_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError as $d_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError };
